/**
 * Libraries
 */

import { SettingsType } from '@generatedTypes';
import { defineStore } from 'pinia';

/**
 * Utils
 */

import { TypeSafeObjectFromEntries } from '@shared/types/Helpers';

/**
 * Types
 */

import type { Settings } from '@generatedTypes';

type SettingsStore = {
  settings: {
    [key in SettingsType]: Settings;
  };
};

function defaultSettings(): SettingsStore['settings'] {
  return TypeSafeObjectFromEntries(
    Object.values(SettingsType).map((type) => [
      type,
      { type, is_active: false, data: {} },
    ]),
  );
}

const useSettingsStore = defineStore('settings', {
  state: (): SettingsStore => {
    return {
      settings: defaultSettings(),
    };
  },
  getters: {
    getSettings: (state) => state.settings,
    getSpecificSettings:
      (state) =>
      (types: SettingsType[]): Partial<SettingsStore['settings']> =>
        types.reduce(
          (acc, role) => ({
            ...acc,
            [role]: state.settings[role],
          }),
          {},
        ),
    getSetting: (state) => (type: SettingsType) => state.settings[type],
  },
  actions: {
    setSettings(settings: Settings[]) {
      for (let i = 0; i < settings.length; i++) {
        const setting = settings[i];
        this.settings[setting.type] = setting;
      }
    },
  },
});

export { useSettingsStore, SettingsStore };
